import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ArrowDown, Sailboat } from "lucide-react";

export default function Hero() {
  const { t } = useTranslation();
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="hero-bg relative min-h-[100vh] flex flex-col justify-end"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="max-w-[1400px] mx-auto w-full px-6 lg:px-12 pb-20 lg:pb-28 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="text-white max-w-4xl"
        >
          <div className="flex items-center gap-3 mb-8">
            <span className="w-10 h-px bg-[#D1BFAe]" />
            <span className="overline text-[#D1BFAe]">{t("hero.eyebrow")}</span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-serif-display text-[3.2rem] sm:text-7xl lg:text-[7rem] leading-[0.95] tracking-tight"
          >
            {t("hero.title_pre")}
            <br />
            <em className="italic font-light text-[#D1BFAe]">{t("hero.title_em")}</em>
            {t("hero.title_post")}
          </h1>

          <p className="mt-10 max-w-xl font-body text-white/85 text-base lg:text-lg font-light leading-relaxed">
            {t("hero.body")}
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-5">
            <a
              href="#booking"
              data-testid="hero-cta-book"
              className="btn-primary on-dark"
              style={{ background: "#D1BFAe", color: "#0A1B35", borderColor: "#D1BFAe" }}
            >
              {t("hero.cta_book")}
            </a>
            <a href="#fleet" data-testid="hero-cta-fleet" className="btn-outline">
              {t("hero.cta_fleet")}
            </a>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/80 flex flex-col items-center gap-2"
      >
        <span className="overline text-[0.6rem]">{t("hero.scroll")}</span>
        <ArrowDown className="w-4 h-4 animate-bounce" />
      </motion.div>

      <div className="absolute top-28 right-8 hidden lg:flex flex-col items-end gap-3 text-white/80">
        <Sailboat className="w-5 h-5" strokeWidth={1.2} />
        <div className="writing-vertical overline text-[0.6rem]" style={{ writingMode: "vertical-rl" }}>
          41.1°N · 20.8°E
        </div>
      </div>
    </section>
  );
}
